import axios from '../../plugins/axios'
import fileDownload from 'js-file-download'

export const listWithdrawals = ({ commit }, { params } = {}) => {
  return axios.get('/withdrawal', { params })
    .then((response) => {
      commit('SET_WITHDRAWALS', response.data.rows)
      return response
    })
    .catch(err => err.response)
}

export const getWithdrawalDetail = ({ commit }, { withdrawalId } = {}) => {
  if (!withdrawalId) {
    throw new Error('withdrawalId es requerido')
  }
  return axios.get(`/withdrawal/${withdrawalId}`)
    .then((response) => {
      // commit('SET_WITHDRAWAL', response.data)
      return response
    })
    .catch(err => err.response)
}

export const createWithdrawal = (_, { data }) => {
  const config = {
    headers: { 'Content-Type': 'multipart/form-data' }
  }
  return axios.post('/withdrawal', data, config)
    .then(response => {
      return response
    })
    .catch(err => err.response)
}

export const createPickupRequest = (_, { data }) => {
  return axios.post('/withdrawal/pickup-request', data)
    .then(response => {
      return response
    })
    .catch(err => err.response)
}

export const updateWithdrawal = (_, { withdrawalId, data }) => {
  return axios.put(`/withdrawal/${withdrawalId}`, data)
    .then(res => {
      return res.data
    })
    .catch(err => err.response)
}

export const exportPackagesWithdrawals = (_, { params } = {}) => {
  return axios.get('/export-withdrawal', { params, responseType: 'blob' })
    .then(response => {
      fileDownload(response.data, response.headers['content-disposition'].split('filename=')[1])
      return response
    })
    .catch(err => err.response)
}

export const exportPackagesWithdrawalsNoDrivIn = (_, { params } = {}) => {
  return axios.get('/export-withdrawal-nodrivin', { params, responseType: 'blob' })
    .then(response => {
      fileDownload(response.data, response.headers['content-disposition'].split('filename=')[1])
      return response
    })
    .catch(err => err.response)
}

export const checkWithdrawalHour = (_, data) => {
  return axios.post('/check-withdrawal-hour', data)
    .then(response => {
      return response.data
    })
    .catch(err => err.response)
}

export const getSameDateWithdrawals = (_, { params } = {}) => {
  return axios.get('/same-date-withdrawal', { params })
    .then(response => {
      return response.data
    })
    .catch(err => err.response)
}

export const getWithdrawalSizeCounts = (_, { params } = {}) => {
  return axios.get('/withdrawal/size-counts', { params })
    .then(response => {
      return response
    })
    .catch(err => err.response)
}
